module.exports = __webpack_public_path__ + "static/img/btn-start.73b679b7.png";